import EmailVerified from './EmailVerified';
import { LoadingOverlay } from '@/Components/shared';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';

function EmailVerifiedPage() {
    const { isLoading } = useUserSignupNavigationContext();

    return isLoading ? <LoadingOverlay /> : <EmailVerified />;
}

export default EmailVerifiedPage;
